import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    let stars = "";
    
    for (let i = 0; i < fullStars; i++) {
      stars += "★";
    }
    if (hasHalfStar) {
      stars += "☆";
    }
    for (let i = fullStars + (hasHalfStar ? 1 : 0); i < 5; i++) {
      stars += "☆";
    }
    return stars;
  };

  return (
    <div className="shop main">
      <main>
        <div className="shop-header">
          <h1 className="shop-title">New Arrivals</h1>
          <div className="shop-sort">
            <span>Sort: Featured</span>
          </div>
        </div>

        <div className="products-grid">
          {productData.map((product) => (
            <Link 
              key={product.id} 
              to={`/shopDetails/${product.id}`}
              onClick={toTop}
              className="product-card"
            >
              <div className="product-card-image">
                <img src={product.image} alt={product.name} />
                {product.price === "217.00" && <span className="sold-out-badge">Sold out</span>}
              </div>
              <div className="product-card-info">
                <p className="product-card-brand">{product.name.split(' ')[0]}</p>
                <p className="product-card-name">{product.name}</p>
                {product.reviews !== "0" && (
                  <div className="product-card-rating">
                    <span className="stars">{renderStars(product.rating)}</span>
                    <span className="rating-score">{product.rating}</span>
                  </div>
                )}
                <p className="product-card-price">${product.price}</p> 
              </div>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}

export default Shop;
